import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { PayOnAccountPaymentPreviewV1Response } from '@arc/unified-payments-frontend/shared-payment';

export const PoaPaymentDetailsPaymentInformationApiActions = createActionGroup({
  source: 'POA Payment Details - Payment Information API',
  events: {
    'Payment Preview Updated': props<{
      payload: PayOnAccountPaymentPreviewV1Response;
    }>(),
    'Payment Preview Update Error': props<{ error: HttpErrorResponse }>(),
  },
});
